import PickBotStep from "containers/OnboardingPlaybook/PickBotStep"
import TargetingStep from "containers/OnboardingPlaybook/TargetingStep"

export default Object.freeze([
  {
    route: '/pick-bot',
    component: PickBotStep,
  },
  {
    route: '/targeting',
    component: TargetingStep,
  },
])



// WEBPACK FOOTER //
// ./src/flows/OnboardingFlow/OnboardingPlaybookFlow/routes.js